// ----------------------------------------------------------------------------
// Section: Featured Reviews
// ----------------------------------------------------------------------------

import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
import 'swiper/css/pagination';
import './_featured-reviews.scss';

// Swiper loop mode checks real slide count against slidesPerView and may disable
// navigation when count < slidesPerView (even with loop active, clones are not counted).
// Duplicating slides ensures watchOverflow never blocks nav regardless of content count.
// (Same approach as image-and-cards.js — kept in sync so both carousels behave/look alike.)
var MIN_SLIDES = 9;
var instanceIndex = 0;
function initFeaturedReviews() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  container.querySelectorAll('[data-featured-reviews-swiper]').forEach(slider => {
    var section = slider.closest('.featured-reviews');
    if (!section) return;
    var wrapper = slider.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    var originalSlides = [...wrapper.querySelectorAll('.swiper-slide')];
    var slideCount = originalSlides.length;
    if (slideCount === 0) return;

    // Mark originals so CSS can hide duplicates in locked state
    originalSlides.forEach(slide => slide.setAttribute('data-original', ''));
    while (wrapper.querySelectorAll('.swiper-slide').length < MIN_SLIDES) {
      originalSlides.forEach(slide => {
        var clone = slide.cloneNode(true);
        clone.removeAttribute('data-original');
        wrapper.appendChild(clone);
      });
    }
    var next = section.querySelector('.featured-reviews__arrow--next');
    var prev = section.querySelector('.featured-reviews__arrow--prev');
    var dotsEl = section.querySelector('.featured-reviews__dots');
    var uniqueClass = "featured-reviews-pagination-".concat(instanceIndex++);
    dotsEl === null || dotsEl === void 0 || dotsEl.classList.add(uniqueClass);
    var paginationSelector = ".".concat(uniqueClass);
    new Swiper(slider, {
      modules: [Navigation, Pagination, A11y, Keyboard],
      // loop: true is required for centeredSlides to show partial slides on BOTH sides.
      // Without loop, slide 0 has no predecessor — the left side is empty on initial render.
      loop: true,
      slidesPerView: 1.25,
      centeredSlides: true,
      spaceBetween: 10,
      watchSlidesProgress: true,
      watchOverflow: false,
      keyboard: true,
      a11y: {
        slideRole: null
      },
      navigation: {
        nextEl: next,
        prevEl: prev
      },
      pagination: {
        el: paginationSelector,
        clickable: true,
        renderBullet(index, className) {
          if (index >= slideCount) return '';
          return "<span role=\"button\" tabindex=\"0\" class=\"".concat(className, "\"></span>");
        }
      },
      breakpoints: {
        769: {
          slidesPerView: 3.5,
          centeredSlides: true,
          spaceBetween: 10
        }
      },
      on: {
        init(s) {
          updateLockState(s);
          updateBullets(s);
        },
        breakpoint(s) {
          updateLockState(s);
        },
        snapIndexChange(s) {
          updateBullets(s);
        }
      }
    });
    function updateLockState(s) {
      var isLocked = slideCount <= Math.floor(s.params.slidesPerView);
      section.classList.toggle('featured-reviews--locked', isLocked);
      s.allowTouchMove = !isLocked;
    }
    function updateBullets(s) {
      if (!dotsEl) return;
      var bullets = dotsEl.querySelectorAll('.swiper-pagination-bullet');
      var activeIndex = s.realIndex % slideCount;
      bullets.forEach((bullet, i) => {
        if (i === activeIndex) {
          bullet.setAttribute('aria-current', 'true');
        } else {
          bullet.removeAttribute('aria-current');
        }
      });
    }
  });
}
initFeaturedReviews();
document.addEventListener('shopify:section:load', _ref => {
  var {
    target
  } = _ref;
  initFeaturedReviews(target);
});